import React from "react";
import Switch from "@mui/material/Switch";
import { FormControl, FormLabel } from "@mui/material";
import {
  setIsDevotionMultiple,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import { useDispatch, useSelector } from "react-redux";
import { DEVOTION } from "../../constants";

const IsDevotionMultiple = ({ label }) => {
  const dispatch = useDispatch();
  
  // Get values from Redux store
  const isDevotionMultiple = useSelector(
    (state) => state.contentForm.isDevotionMultiple
  );
  const contentType = useSelector((state) => state.contentForm.contentType);

  const handleChange = () => {
    // Check if contentType matches DEVOTION
    if (contentType === DEVOTION) {
      dispatch(setIsDevotionMultiple(!isDevotionMultiple));
    } else {
      dispatch(setIsDevotionMultiple(false));
    }
  };

  return (
    <FormControl>
      <FormLabel component="legend">{label}</FormLabel>
      <Switch
        checked={isDevotionMultiple}
        onChange={handleChange}
        inputProps={{
          "aria-label": "Do you want to upload batch files for devotion content?",
        }}
      />
    </FormControl>
  );
};

export default IsDevotionMultiple;